<div class="row col-10">
  <p>Selecciona los puestos que serán asignados a este perfil</p>
  <div class="col-12">
    <input matInput type="text" id="name" class="form-control" [(ngModel)]="profileName" disabled>
  </div>
  <hr class="mt-4 separator">
  <!-- TOTAL GLOBAL -->
  <div style="margin-left: 10px;">
    <div class="div-counter col-12 row">
      <div class="col-6">
        <strong> Total colaboradores con este perfil {{ totalNumberFunctions + totalNumberExcel }} </strong> 
      </div>
      <div class="col-6 text-end">
        <strong> Última actualización: {{ profileUpdateInfo.lastUpdate }} </strong> 
      </div>
    </div>
  </div>
  
  <!-- TABS -->
  <ul class="nav nav-tabs col mt-3 mb-3 col-12" id="myTab" role="tablist">
    <div class="navigator-tab">
      <li class="nav-item" role="presentation">
        <button 
          class="nav-link global-tab tab-button"
          [ngClass]="{'active': onActiveTab === true}"
          id="home-tab" 
          data-bs-toggle="tab" 
          type="button"
          role="tab" 
          aria-controls="home" 
          (click)="showSapFunction = true"
        >
          Funciones SAP
        </button>
      </li>
    </div>
    <div class="navigator-tab">
      <li class="nav-item" role="presentation">
        <button 
          class="nav-link global-tab tab-button" 
          [ngClass]="{'active': onActiveTab === false}"
          id="profile-tab" 
          data-bs-toggle="tab"
          type="button"
          role="tab" 
          aria-controls="profile" 
          (click)="showSapFunction = false"
        >
          No. de empleado
        </button>
      </li>
    </div>
  </ul>

  <!-- DROPDOWN SAP Functions -->
  <div class="col-12 mb-3" *ngIf="showSapFunction">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <div ngbDropdown style="width: 220px;">
        <button type="button" class="btn toggle-button" id="cargaExcel" ngbDropdownToggle> Cargar funciones </button>
        <div ngbDropdownMenu aria-labelledby="cargaExcel">
          <button ngbDropdownItem type="button" (click)="downloadFile('funciones')"> Descargar formato </button>
          <input class="input-file" type="file" accept=".xlsx" (change)="uploadExcel($event, 'funciones')" #fileFunctions>
          <button ngbDropdownItem type="button" (click)="fileFunctions.click()"> Subir formato </button>
        </div>
      </div>
    </div>
  </div>

  <!-- SEARCH BY SAP FUNCTIONS -->
  <div class="row col-12 search-input" *ngIf="showSapFunction">
    <mat-icon class="type-icon icon-search" style="margin-right: 18px;">
      {{ 'search' }}
    </mat-icon> 
    <input 
      matInput 
      name="search" 
      [(ngModel)]="searchText" 
      autocomplete="off"      
      class="form-control" 
      placeholder="Buscar por id de función o nombre" 
      style="padding-left: 42px; margin-left: 5px;"
      #input
    >
  </div>
  <!-- SELECT EXCEL FILE -->
  <div class="row col-12 search-input" style="padding-right: 0px;" *ngIf="!showSapFunction">
    <div class="col-8 container-excel">
      <div class="btn-group" role="group" aria-label="Button group" style="margin-top: 5px;" *ngIf="onValidateEmployees">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-excel radius-btn-excel" disabled>
            {{ fileName }}
          </button>
        </div>
        <button type="button" class="btn btn-icon radius-btn-excel" (click)="cleanFile()">
          <mat-icon class="icon-c-folder icon-display filter-red" svgIcon="icon-x"></mat-icon>
        </button>
      </div>
    </div>

    <!-- DROPDOWN EXCEL -->
    <div class="mt-1 offset-1 col-3 select-div">
      <button  class="btn toggle-button" type="button" style="width: 100%;" mat-button> 
        <div class="valign-center" [matMenuTriggerFor]="submenu">
          <span> Cargar Excel </span>
          <li class="material-icons"> arrow_drop_down </li>
        </div>
      </button>

      <mat-menu #submenu="matMenu">
        <button type="button" mat-menu-item [matMenuTriggerFor]="excel"> Carga Excel </button>
        <button type="button" mat-menu-item [matMenuTriggerFor]="excel_x3"> Carga Excel X3 </button>
      </mat-menu>

      <mat-menu #excel="matMenu">
        <button type="button" mat-menu-item (click)="downloadFile('excel')"> Descargar formato </button>
        <input class="input-file" type="file" accept=".xlsm" (change)="uploadExcel($event, 'excel')" #fileInput>
        <button type="button" mat-menu-item (click)="fileInput.click()"> Subir formato </button>
      </mat-menu>

      <mat-menu #excel_x3="matMenu">
        <button type="button" mat-menu-item (click)="downloadFile('excel_x3')"> Descargar formato X3 </button>
        <input class="input-file" type="file" accept=".xlsx" (change)="uploadExcel($event, 'excel_x3')" #fileX3>
        <button type="button" mat-menu-item (click)="fileX3.click()"> Subir formato X3 </button>
      </mat-menu>
    </div>

    <!-- SEARCH EMPLOYEE -->
    <div class="row mt-3 search-input" *ngIf="!showSapFunction">
      <mat-icon class="type-icon icon-search" style="margin-right: 18px;">
        {{ 'search' }}
      </mat-icon> 
      <input 
        matInput 
        name="search" 
        [(ngModel)]="searchEmployee" 
        autocomplete="off"      
        class="form-control" 
        placeholder="Buscar por número de empleado o nombre" 
        style="padding-left: 42px; margin-left: 5px;"
        #input
      />
    </div>
  </div>

  <!-- SAP FUNCTIONS -->
  <div class="col-md-12" *ngIf="showSapFunction">
    <div class="card custom-inner-card mt-4">
      <div class="card-header">
        <div class="row">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-12">
                Funciones SAP
              </div>
            </div>
          </div>
          <div class="col-md-2">
          </div>
        </div>
      </div>
      <div class="card-body" style="overflow: auto; height: 350px;">
        <strong> Total colaboradores {{ totalNumberFunctions }} </strong> 
        <div class="row">
          <div class="col-md-12 mt-3">
            <ul style="list-style: none; padding-left: 0px;"> 
              <li *ngFor="let function of functionsList | filter:searchText"> 
                <div class="d-flex">
                  <div class="p-2">
                    <mat-checkbox [(ngModel)]="function.isSelected" (change)="fetchSelectedItems()">
                      <b>{{function.idFuncion}}</b> - {{function.nombreFuncion}} ({{function.total}} - empleados)
                    </mat-checkbox>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- CARGA POR EXCEL -->
  <div class="card col-md-12 mt-3 segm-tab" *ngIf="!showSapFunction">
    <ul class="nav nav-tabs" style="padding-left: 0px;" role="tablist">
      <div class="navigator-tab">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link tab-button active"
            id="home-tab" 
            data-bs-toggle="tab" 
            data-bs-target="#visita-efectiva" 
            type="button"
            role="tab" 
            aria-controls="home" 
            aria-selected="true"
            (click)="onChangeTable(true)"
          >
            <small> Número de empleados </small>
          </button>
        </li>
      </div>
      <div class="navigator-tab">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link tab-button" 
            id="profile-tab" 
            data-bs-toggle="tab"
            type="button"
            role="tab" 
            aria-controls="profile" 
            aria-selected="false"
            (click)="onChangeTable(false)"
          >
            <small> Denegados ({{ notAllowedEmployees.length }}) </small>
          </button>
        </li>
      </div>
    </ul>
    <div class="card-body" style="overflow: auto; height: 330px;">
      <div class="row">
        <!-- EXCEL VALIDATOR COMPONENT -->
        <strong *ngIf="showAllowedEmployees"> Total colaboradores {{ totalNumberExcel }} </strong> 
        <strong *ngIf="!showAllowedEmployees"> Total no encontrados {{ notAllowedEmployees.length }} </strong> 
        <div class="row">
          <div class="col-md-12 mt-3" *ngIf="showAllowedEmployees">
            <ul style="list-style: none; padding-left: 0px;"> 
              <li> 
                <div class="d-flex col-12">
                  <div class="p-2 col-12">
                    <div *ngFor="let employee of allowedEmployees | filter:searchEmployee">
                      <!-- <p> <strong> {{ employee.employee_number }} </strong> - {{ employee.employee_name }} </p> -->
                      <p> {{ employee.employee_data }} </p>
                    </div>
                  </div>
                  <div class="p-2 empty-employees offset-4 col-4" *ngIf="!onValidateEmployees">
                    <p> Sube el formato con los números de empleados </p>
                  </div> 
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md-12 mt-3" *ngIf="!showAllowedEmployees">
            <ul style="list-style: none; padding-left: 0px;"> 
              <li> 
                <div class="d-flex col-12">
                  <div class="p-2 col-12">
                    <div *ngFor="let notAllowed of notAllowedEmployees">
                      <p style="margin-bottom: 5px;"> {{ notAllowed }} </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
